import { cn } from '../../../lib/utils';
import { Skeleton } from '../../atoms/skeleton';

export function ShellSkeleton({ className }: { className?: string }) {
  return (
    <div className={cn('flex h-full min-h-screen bg-background', className)}>
      {/* Icon rail skeleton */}
      <div className="hidden w-16 flex-col items-center gap-4 border-r border-border bg-sidebar py-4 lg:flex">
        <Skeleton className="size-8 rounded-lg" />
        <Skeleton className="size-8 rounded-lg" />
        <Skeleton className="size-8 rounded-lg" />
        <Skeleton className="size-8 rounded-lg" />
      </div>
      {/* Expanded sidebar skeleton */}
      <div className="hidden w-64 flex-col border-r border-border bg-sidebar p-4 lg:flex">
        <Skeleton className="mb-4 h-8 w-32" />
        <Skeleton className="mb-2 h-6 w-full" />
        <Skeleton className="mb-2 h-6 w-full" />
        <Skeleton className="mb-2 h-6 w-3/4" />
      </div>
      {/* Main area skeleton */}
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="flex h-14 items-center border-b border-border px-4">
          <Skeleton className="h-8 w-48" />
        </div>
        <div className="flex-1 p-6">
          <Skeleton className="h-64 w-full rounded-xl" />
        </div>
      </div>
    </div>
  );
}
